import { api } from '@/utils/client';

const state = {
	detail: {
		plan: '', name: '', slug: '', logo_url: '', domains: [], managers: [], id: 0
	},
	detailCopy: {
		name: '', slug: ''
	},
	user: {name: '', email: '', permissions: []},
	teamMember: {name: '', email: '', role: '', permissions: []},

	apiKey: {},
	apiKeys: {data: []}
}

// actions
const actions = {
	async fetchTeam(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId);
			context.commit('fetchTeam', response.data);
			return response;
		} catch (e) {
			if (e && e.response && e.response.data.code === 'ws_api_get_team_404') {
				context.dispatch('onLogout');
				window.location.href = "/pro/login";
			}
			console.log({e});
			throw e;
		}
	},
	async checkTeamBalance(context, amount) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/check-balance?amount=' + amount);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateTeam(context, data) {
		try {
			let response = await api.put('/teams/' + context.rootState.teamId, data);
			context.commit('fetchTeam', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateCurrentUser(context, data) {
		try {
			let response = await api.put('/teams/' + context.rootState.teamId + '/current-user', data);
			context.commit('fetchCurrentUser', response.data);
			return response;
		} catch (e) {
			if (e && e.response && e.response.data.code === 'ws_api_get_team_current_user_404') {
				context.dispatch('onLogout');
				 window.location.href = "/pro/login";
			}
			console.log(e);
			throw e;
		}
	},

	async fetchTeamMember(context, userId) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/members/' + userId);
			context.commit('fetchTeamMember', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchTeamMembers(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/members');
			context.commit('fetchTeamMembers', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async addTeamMember(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId +'/members', data);
			context.commit('fetchTeamMembers', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async updateTeamMember(context, {userId,data}) {
		try {
			let response = await api.put('/teams/' + context.rootState.teamId + '/members/' + userId, data);
			context.commit('fetchTeamMember', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async deleteTeamMember(context, userId) {
		try {
			let response = await api.delete('/teams/' + context.rootState.teamId + '/members/' + userId);
			context.commit('fetchTeamMembers', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

	async addTeamDomain(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId +'/domains', data);
			context.commit('fetchTeamDomains', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async deleteTeamDomain(context, data) {
		try {
			let response = await api.delete('/teams/' + context.rootState.teamId + '/domains', {data: data});
			context.commit('fetchTeamDomains', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

	async addTeamIntegration(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId +'/integrations', data);
			context.commit('fetchTeam', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async deleteTeamIntegration(context, data) {
		try {
			let response = await api.delete('/teams/' + context.rootState.teamId + '/integrations', {data: data});
			context.commit('fetchTeam', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

	async uploadTeamImage(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId +'/upload', data);
			context.commit('fetchTeam', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},

	async fetchTeamApiKey(context, keyId) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/api_keys/' + keyId);
			context.commit('fetchTeamApiKey', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchTeamApiKeys(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/api_keys');
			context.commit('fetchTeamApiKeys', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async createTeamApiKey(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId +'/api_keys', data);
			context.commit('fetchTeamApiKey', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async deleteTeamApiKey(context, keyId) {
		try {
			let response = await api.delete('/teams/' + context.rootState.teamId + '/api_keys/' + keyId);
			context.commit('fetchTeamApiKeys', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async getTeamMasterKey(context) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/api_keys/master');
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async upgradeToBookblockHubPro(context, data) {
		try {
			let response = await api.post('/teams/' + context.rootState.teamId + '/request-plan-upgrade', data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
}
// mutations
const mutations = {
	fetchTeam(state, data) {
		state.detail = data;
		state.detailCopy = data;
	},
	fetchTeamDomains(state, data) {
		state.detail.domains = data;
	},
	fetchTeamMember(state, data) {
		state.teamMember = data;
	},
	fetchTeamMembers(state, data) {
		state.detail.managers = data;
	},
	fetchTeamApiKey(state, data) {
		state.apiKey = data;
	},
	fetchTeamApiKeys(state, data) {
		state.apiKeys = data;
	}

}

export default {
	state,
	actions,
	mutations
}
